import script from "./RightSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./RightSidebar.vue?vue&type=script&setup=true&lang=js"

import "./RightSidebar.vue?vue&type=style&index=0&id=9888eb16&lang=css"
import "./RightSidebar.vue?vue&type=style&index=1&id=9888eb16&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9888eb16"]])

export default __exports__